import { Stack } from "@mui/material";

import { cn } from "../utils/styling";
import { IconButton } from "./IconButton";
import { SuccessCheckmarkIcon } from "./IconsTextsUtils";

type SelectedFileBannerProps = {
  className?: string;
  fileName: string;
  onRemove?: () => void;
  showCheckmark?: boolean;
};

export const SelectedFileBanner = ({
  className,
  fileName,
  onRemove,
  showCheckmark = true,
}: SelectedFileBannerProps) => (
  <Stack
    className={cn(
      "h-12 w-full gap-3 rounded-md border border-lds-purpose-status-positive-subtle bg-lds-purpose-status-positive-soft px-3 opacity-75",
      className
    )}
  >
    {showCheckmark && <SuccessCheckmarkIcon />}
    <span className="min-w-0 flex-1 truncate text-lds-foreground-secondary font-ds-body-semibold-sm">{fileName}</span>
    {onRemove && (
      <IconButton
        buttonProps={{
          className: "shrink-0",
          onClick: onRemove,
          variant: "tertiary",
        }}
        iconProps={{ iconName: "Close" }}
      />
    )}
  </Stack>
);
